/**
 * 選考ステップのIDに基づいて未ログインユーザーに表示する文字数制限を決定する
 * @param stepId 選考ステップのID
 * @returns 表示する文字数
 */
export const getVisibleCharLengthByStepId = (stepId: number): number => {
  // ステップIDに応じて表示文字数を変える場合はここでロジックを実装
  switch (stepId) {
    case 1: // 説明会
    case 2: // エントリーシート
      return 50;
    case 3: // 筆記試験・WEBテスト・適性検査
    case 4: // グループディスカッション
    case 5: // その他の選考（ジョブ・インターンなど）
    case 6: // 面接
      return 100;
    default:
      return 100; // デフォルトは100文字
  }
};
